"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAuthLogout = exports.handleAuthRedirection = exports.redirectToAuth0Form = void 0;
var apiService_1 = __importDefault(require("../../services/apiService"));
var controller = null;
var redirectToAuth0Form = function ($state, screenHint, loginHint) { return __awaiter(void 0, void 0, void 0, function () {
    var currentUrl, payload, response, location_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // Cancel the previous request if it exists
                if (controller) {
                    controller.abort();
                }
                // Create a new AbortController instance for the new request
                controller = new AbortController();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                currentUrl = window.location.href;
                payload = {
                    screenHint: screenHint,
                    loginHint: loginHint,
                    returnTo: currentUrl,
                };
                return [4 /*yield*/, apiService_1.default.redirectToAuth0Form(null, payload, controller)];
            case 2:
                response = _a.sent();
                location_1 = response.headers.location;
                if (!location_1 && !$state) {
                    console.error('Header is not accessible and $state is not available in React interceptor');
                }
                if (!location_1 && $state) {
                    $state.go('app.auth0ErrorPage');
                }
                else {
                    window.location.replace(location_1);
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error(' api/auth0/login error', error_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.redirectToAuth0Form = redirectToAuth0Form;
var handleAuthRedirection = function (currentUser, $state, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var user, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 4]);
                return [4 /*yield*/, apiService_1.default.getUser()];
            case 1:
                user = _a.sent();
                if (currentUser) {
                    currentUser.logIn(user.data);
                }
                callback();
                return [3 /*break*/, 4];
            case 2:
                error_2 = _a.sent();
                console.error('error', error_2);
                return [4 /*yield*/, (0, exports.redirectToAuth0Form)($state)];
            case 3:
                _a.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.handleAuthRedirection = handleAuthRedirection;
var handleAuthLogout = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response, location_2, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, apiService_1.default.logout(null)];
            case 1:
                response = _a.sent();
                location_2 = response.headers.location;
                // NOTE: if the Location header is not accessible for some reason, the backend needs to add an extra header to the response.
                // we will see about that in staging
                window.location.replace(location_2);
                return [3 /*break*/, 3];
            case 2:
                error_3 = _a.sent();
                console.error('Logout api error', error_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.handleAuthLogout = handleAuthLogout;
